export default {
  okText: 'OK',
  closeText: 'Close',
  cancelText: 'Cancel',
  loadingText: 'Loading...',
  saveText: 'Save',
  delText: 'Delete',
  resetText: 'Reset',
  searchText: 'Search',
  queryText: 'Search',

  inputText: 'Please enter',
  chooseText: 'Please choose',

  redo: 'Refresh',
  back: 'Back',

  light: 'Light',
  dark: 'Dark',
};
